export default __webpack_public_path__ + "static/media/bell.a58a366e.svg";